import React from 'react';

export default () => {
  return (
    <div style={{ textAlign: 'center', paddingTop: '30px' }}>
      <div>
        <img style={{ maxWidth: '100%' }} src="/img/footer1.png" alt="" />
      </div>
      <br />
      <div>
        <img style={{ maxWidth: '100%' }} src="/img/footer2.png" alt="" />
      </div>
      <br />
      <br />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/Footer.jsx